<div class="page-container">
  <div class="section1">
    <img class="logo" src="assets/images/sparkly_logo.png" alt="Logo">
    <h1>Erstelle Lernkarten mit KI <span class="primary-color">in Sekunden</span></h1>
    <p>Datei hochladen oder Prompt eingeben und Lernkarten innerhalb von wenigen Sekunden erstellen lassen.</p>
    <div class="buttons-container">
      <app-button [text]="'Kostenlos Registrieren'" (clickEvent)="goToRegister()"></app-button>
      <app-button [text]="'Zuerst Ausprobieren'" [style]="'outlined'" (clickEvent)="scrollToDemo()"></app-button>
    </div>
  </div>
  
  <section #demoSection>
    <app-create-upload-flashcards [isDemo]="true"></app-create-upload-flashcards>
  </section>
</div>